export interface ActionParam {
  key: string;
  data_type: number;
  variate_type: number;
  is_assigned: boolean;
  int_val?: number;
  string_val?: string;
  float_val?: number;
  bool_val?: boolean;
}

export interface ActionParams {
  [key: string]: ActionParam;
}

export type Values = {
  [key in keyof ActionParams]: number|string|boolean;
}

export enum DataType{
  IntVal = 1,
  FloatVal,
  StringVal,
  BoolVal
}

export function dataTypeConvert(data:ActionParam, value:number|string|boolean) {
  switch (data.data_type) {
    case DataType.IntVal:
      return { ...data, ...{ int_val: Number(value), is_assigned: true }};
    case DataType.FloatVal:
      return { ...data, ...{ float_val: Number(value), is_assigned: true }};
    case DataType.StringVal:
      return { ...data, ...{ string_val: String(value), is_assigned: true }};
    case DataType.BoolVal:
      return { ...data, ...{ bool_val: value as boolean, is_assigned: true }};
  }
}


export const assignParams = (params: ActionParams, values:Values) => {
  if (!params) {
    return {};
  }

  const resultParams: any = {};
  Object.keys(params)
    .forEach((key) => {
      if (params[key]?.is_assigned) {
        resultParams[key] = params[key];
      } else {
        resultParams[key] = dataTypeConvert(params[key], values[key]);
      }
    });

  return resultParams;
};
